export default __webpack_public_path__ + "static/media/SamsungOne-300_v1.0.8d4bb6e2.ttf";